import { Component, SimpleChanges, OnInit, OnChanges, ViewChild, ViewContainerRef, ComponentFactoryResolver, Input, Output, EventEmitter } from '@angular/core';
// import { EFormPage } from './page';
// import { R3TargetBinder } from '@angular/compiler';

@Component({
    selector: 'eform',
    templateUrl: './eform.html',
    styleUrls: ['./eform.scss']
  })
export class EForm implements OnInit, OnChanges {

    @ViewChild('form', {static: true, read: ViewContainerRef})
    form: ViewContainerRef;

    @Input('layout')
    layout: any = {
        title: 'Testing E-Form',
        pages: [{
            title: 'Personal Data',
            sections: [{
                title: null,
                orientation: 'vertical',
                size: 6,
                border: 'none',
                controls: [
                    {
                        name: 'full_name',
                        type: 'input',
                        datatype: 'string',
                        label: 'Full Name',
                        size: 4,
                        hint: 'Please enter your full name',
                        visible: 1,
                        required: 1
                    },
                    {
                        name: 'address',
                        type: 'input',
                        datatype: 'string',
                        label: 'Address',
                        size: 6,
                        hint: 'Please enter your address.',
                        visible: 1,
                        required: 0
                    }
                ]
            }, {
                title: null,
                orientation: 'vertical',
                size: 3,
                border: 'none',
                controls: [
                    {
                        name: 'gender',
                        type: 'input',
                        datatype: 'enum',
                        label: 'Gender',
                        hint: 'Please enter your gender',
                        visible: 1,
                        required: 1,
                        enum: [{id: 'M', name: 'Male'},{id: 'F', name: 'Female'}]
                    },
                    {
                        name: 'age',
                        type: 'input',
                        datatype: 'integer',
                        label: 'Age (Yrs)',
                        visible: 1,
                        required: 1,
                        hint: 'Please enter your age in years. Do not round up.'
                    }
                ]
            }],
        },
        {
            title: 'Contact Information',    
            sections: [{
                title: 'Contact Information',
                orientation: 'vertical',
                size: 8,
                border: 'line',
                controls: [
                    {
                        name: 'address',
                        type: 'input',
                        datatype: 'text',
                        label: 'Mail Address',
                        size: 5,
                        visible: 1,
                        required: 0,
                        hint: 'Please enter your full address'
                    },
                    {
                        name: 'phone',
                        type: 'input',
                        datatype: 'string',
                        label: 'Personal Phone',
                        size: 3,
                        visible: 1,
                        required: 0,
                        hint: 'Please enter your phone number.'
                    }
                ]
            }]
        }]
    }

    @Output('change')
    onChange: EventEmitter<{name: string, value: any}> = new EventEmitter<{name: string, value: any}>();

    constructor(private componentFactoryResolver: ComponentFactoryResolver) {}

    ngOnInit() {
        this.load();
    }

    ngOnChanges(changes : SimpleChanges) {
        this.load();
    }

    load() {
        // this.form.clear();

        // for(let page of this.layout.pages) {
        //     this.createPage(page, this.form);
        // }
    }

    // createPage(page: any, parent: ViewContainerRef) {
    //     const pageFactory = this.componentFactoryResolver.resolveComponentFactory(EFormPage);
    
    //     const pageRef = parent.createComponent(pageFactory);
    //     pageRef.instance.layout = page;

    //     console.log('Created page', pageRef);
    // }

    valueChange(event: {name: string, value: any}) {

        if (this.layout.target) {
            this.layout.target[event.name] = event.value;
        }
        // alert(JSON.stringify(event));
        this.onChange.emit(event);
    }
    
}